// Microsoft Authentication Configuration

export const msalConfig = {
    auth: {
        // REPLACE WITH YOUR ACTUAL CLIENT ID FROM AZURE AD
        clientId: "1f6e537c-c7ff-489c-b4b2-dd1f9bd9a236",

        // For multi-tenant (any Microsoft account):
        //authority: "https://login.microsoftonline.com/common",

        // For single tenant (CareLync only), use:
         authority: "https://login.microsoftonline.com/b3e21f27-c002-4d1c-bfb8-72795d243aec",

        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "sessionStorage", // or "localStorage" to persist across tabs
        storeAuthStateInCookie: false
    }
};

// Scopes to request during login
export const loginRequest = {
    scopes: ["User.Read"]
};

// Microsoft Graph endpoint for user info
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};